
import { uses } from "~/data/cloudMigration";

export default {
  data() {
    return {
      items: uses,
    };
  },
};
